import React from 'react';
import { Settings, ChevronDown, ChevronUp } from 'lucide-react';

const EngineMachineryCard = ({ 
  engineData,
  setEngineData,
  isExpanded,
  onToggle,
  onAddLogEntry,
  activeVoyage
}) => {
  return (
    <div className="rounded-lg border-2 bg-white border-gray-200">
      <div 
        onClick={onToggle}
        className="p-4 cursor-pointer hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Settings className="h-5 w-5 text-gray-600" />
            <div>
              <h4 className="text-sm font-medium">Engine &amp; Machinery</h4>
              <p className="text-xs text-gray-500">Engine hours and fuel consumption</p>
            </div>
          </div>
          {isExpanded ? 
            <ChevronUp className="h-5 w-5 text-gray-400" /> : 
            <ChevronDown className="h-5 w-5 text-gray-400" />
          }
        </div>
      </div>
      {isExpanded && (
        <div className="px-4 pb-4 border-t border-gray-100">
          <p className="text-sm text-gray-500 mt-4">Engine monitoring coming soon...</p>
        </div>
      )}
    </div>
  );
};

export default EngineMachineryCard;